import { IconButton, Tooltip } from '@mui/material';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useThemeMode } from '../../context/ThemeModeContext';

/** Toggle light / dark theme — persisted in localStorage */
const ThemeModeToggle = ({ size = 'medium', sx }) => {
  const { isDark, toggleMode } = useThemeMode();

  return (
    <Tooltip title={isDark ? 'Açık tema' : 'Koyu tema'}>
      <IconButton
        onClick={toggleMode}
        size={size}
        aria-label={isDark ? 'Açık temaya geç' : 'Koyu temaya geç'}
        sx={sx}
      >
        {isDark ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeModeToggle;
